import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import './Person.scss';
var Person = /*#__PURE__*/function (_Component) {
  function Person() {
    var _this;
    _classCallCheck(this, Person);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Person, [].concat(args));
    /* Utils */
    _defineProperty(_this, "getName", function () {
      var name = '';
      if (_this.props.person != null && _this.props.person.firstName != null) {
        name = _this.props.person.firstName;
      }
      if (_this.props.person != null && _this.props.person.lastName != null) {
        name = name.length > 0 ? name + ' ' + _this.props.person.lastName : _this.props.person.lastName;
      }
      return name;
    });
    _defineProperty(_this, "getInitials", function () {
      var name = _this.getName();
      if (name != null && name.length > 0) {
        var nameSplit = name.split(' ');
        if (nameSplit.length > 1) return nameSplit[0].charAt(0).toUpperCase() + nameSplit[nameSplit.length - 1].charAt(0).toUpperCase();
        if (nameSplit.length == 1) return nameSplit[0].charAt(0).toUpperCase();
      } else {
        return '';
      }
    });
    return _this;
  }
  _inherits(Person, _Component);
  return _createClass(Person, [{
    key: "render",
    value: /* Events */
    // Empty

    /* Render methods */
    function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "person-container",
        style: _objectSpread({
          display: 'inline-block'
        }, this.props.style)
      }, /*#__PURE__*/React.createElement("div", {
        className: "person size--" + this.props.size
      }, /*#__PURE__*/React.createElement("div", {
        className: "avatar"
      }, this.getInitials()), /*#__PURE__*/React.createElement("div", {
        className: "name"
      }, this.getName())), this.props.children ? /*#__PURE__*/React.createElement("div", {
        className: "person-children size--" + this.props.size
      }, this.props.children) : null);
    }
  }]);
}(Component);
/* Class setup */
_defineProperty(Person, "defaultProps", {
  person: {
    firstName: '',
    lastName: '',
    email: '',
    id: ''
  },
  showName: true,
  showAvatar: true,
  size: 'sm'
});
export default Person;